import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { Button } from '@blade/ui-kit'
import { FilterLinesIcon } from '@root/shared/ui-kit'

import { exploreFilterDrawer } from '../../atoms/reatom-explore-filter-drawer'

import type { ExploreFiltersAtom } from '../../atoms'

type ExploreFilterButtonProps = {
  model: ExploreFiltersAtom
  variant?: 'default' | 'floating'
}
export const ExploreFilterButtonSmall = ({
  model,
  variant = 'default',
}: ExploreFilterButtonProps) => {
  const { t } = useTranslation()
  const [appliedFiltersCount] = useAtom(model.appliedFiltersCount)
  const [exploreFilterDrawerState, setExploreFilterDrawerState] = useAtom(
    exploreFilterDrawer.exploreFilterDrawer,
  )
  const closeExploreFilter = useAction(exploreFilterDrawer.closeAction)

  const handleClick = () => {
    if (exploreFilterDrawerState) {
      closeExploreFilter()
    } else {
      setExploreFilterDrawerState(() => model)
    }
  }

  if (variant === 'floating') {
    return (
      <FloatingFilterButton
        $isActive={!!appliedFiltersCount}
        iconLeft={<FilterLinesIcon />}
        size="h28"
        variant="soft"
        radius="full"
        type="button"
        onClick={handleClick}
      >
        {t('common.filter_other')}
      </FloatingFilterButton>
    )
  }

  return (
    <FilterButton
      $isActive={!!appliedFiltersCount}
      iconLeft={
        <FilterLinesIcon
          color={appliedFiltersCount ? 'var(--text-12)' : 'var(--background-8)'}
        />
      }
      size="xs"
      variant="soft"
      radius="rounded"
      type="button"
      onClick={handleClick}
    />
  )
}

const FilterButton = styled(Button)<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive
      ? css`
          color: var(--text-12);
          background: var(--primaryA-2);
          border: 1px solid var(--primary-9);
          &:hover {
            background: var(--primaryA-2);
          }
        `
      : css`
          background: var(--backgroundA-2);
        `}
`

const FloatingFilterButton = styled(FilterButton)`
  --button-radius-full: 5px;

  border-radius: 5px;
  background: rgba(255, 255, 255, 0.08);
`
